import { configureStore } from "@reduxjs/toolkit";
import snackbarSlice from "../pages/shared/snackbar/snackbar-slice";
import itemStatusListSlice from "../pages/admin/item-status/item-status-list/item-status-list-slice";
import itemStatusAddSlice from "../pages/admin/item-status/item-status-add/item-status-add-slice";
import itemStatusEditSlice from "../pages/admin/item-status/item-status-edit/item-status-edit-slice";
import itemStatusDeleteSlice from "../pages/admin/item-status/item-status-delete/item-status-delete-slice";
import itemTypesListSlice from "../pages/admin/item-types/item-types-list/item-types-list-slice";
import itemTypesAddSlice from "../pages/admin/item-types/item-types-add/item-types-add-slice";
import itemTypesEditSlice from "../pages/admin/item-types/item-types-edit/item-types-edit-slice";
import itemTypesDeleteSlice from "../pages/admin/item-types/item-types-delete/item-types-delete-slice";
import itemCategoriesListSlice from "../pages/admin/item-categories/item-categories-list/item-categories-list-slice";
import itemCategoriesAddSlice from "../pages/admin/item-categories/item-categories-add/item-categories-add-slice";
import itemCategoriesEditSlice from "../pages/admin/item-categories/item-categories-edit/item-categories-edit-slice";
import itemCategoriesDeleteSlice from "../pages/admin/item-categories/item-categories-delete/item-categories-delete-slice";
import itemsListSlice from "../pages/admin/items/items-list/items-list-slice";
import itemsAddSlice from "../pages/admin/items/items-add/items-add-slice";
import itemsEditSlice from "../pages/admin/items/items-edit/items-edit-slice";
import itemsDeleteSlice from "../pages/admin/items/items-delete/items-delete-slice";
import forRentWigsListSlice from "../pages/client/for-rent/for-rent-wigs/for-rent-wigs-list/for-rent-wigs-list-slice";
import forRentCostumesListSlice from "../pages/client/for-rent/for-rent-costumes/for-rent-costumes-list/for-rent-costumes-list-slice";
import forRentSetsListSlice from "../pages/client/for-rent/for-rent-sets/for-rent-sets-list/for-rent-sets-list-slice";
import forSaleWigsListSlice from "../pages/client/for-sale/for-sale-wigs/for-sale-wigs-list/for-sale-wigs-list-slice";
import forSaleEssentialsListSlice from "../pages/client/for-sale/for-sale-essentials/for-sale-essentials-list/for-sale-essentials-list-slice";
import forRentCostumesDetailsSlice from "../pages/client/for-rent/for-rent-sets/for-rent-sets-details/for-rent-sets-details-slice";
import forRentSetsDetailsSlice from "../pages/client/for-rent/for-rent-sets/for-rent-sets-details/for-rent-sets-details-slice";
import forRentWigsDetailsSlice from "../pages/client/for-rent/for-rent-wigs/for-rent-wigs-details/for-rent-wigs-details-slice";
import forSaleWigsDetailsSlice from "../pages/client/for-sale/for-sale-wigs/for-sale-wigs-details/for-sale-wigs-details-slice";
import forSaleEssentialsDetailsSlice from "../pages/client/for-sale/for-sale-essentials/for-sale-essentials-list/for-sale-essentials-list-slice";
import itemTabsSlice from "../pages/admin/items/items-list/items-list-details/item-tabs/item-tabs-slice";
import itemInformationListSlice from "../pages/admin/items/items-list/items-list-details/item-tabs/item-information/item-information-list/item-information-list-slice";
import itemPhotosListSlice from "../pages/admin/items/items-list/items-list-details/item-tabs/item-photos/item-photos-list/item-photos-list-slice";
import itemPhotosAddSlice from "../pages/admin/items/items-list/items-list-details/item-tabs/item-photos/item-photos-add/item-photos-add-slice";
import itemPhotosDeleteSlice from "../pages/admin/items/items-list/items-list-details/item-tabs/item-photos/item-photos-delete/item-photos-delete-slice";
import requestRentSlice from "../pages/client/request-rent/request-rent-slice";

import bidsListSlice from "../pages/admin/bids/bid-list/bids-list-slice";
import bidsAddSlice from "../pages/admin/bids/bid-add/bids-add-slice";
import bidsHomeSlice from "../pages/client/bids/bids-home-slice";
import bidItemSlice from "../pages/client/bids/bids-item/bids-item-slice";

export const store = configureStore({
    reducer: {
        snackbarSlice: snackbarSlice,
        itemStatusListSlice:itemStatusListSlice,
        itemStatusAddSlice: itemStatusAddSlice,
        itemStatusEditSlice: itemStatusEditSlice,
        itemStatusDeleteSlice: itemStatusDeleteSlice,
        itemTypesListSlice: itemTypesListSlice,
        itemTypesAddSlice: itemTypesAddSlice,
        itemTypesEditSlice: itemTypesEditSlice,
        itemTypesDeleteSlice: itemTypesDeleteSlice,
        itemCategoriesListSlice: itemCategoriesListSlice,
        itemCategoriesAddSlice: itemCategoriesAddSlice,
        itemCategoriesEditSlice: itemCategoriesEditSlice,
        itemCategoriesDeleteSlice: itemCategoriesDeleteSlice,
        itemsListSlice: itemsListSlice,
        itemsAddSlice: itemsAddSlice,
        itemsEditSlice: itemsEditSlice,
        itemsDeleteSlice: itemsDeleteSlice,
        forRentWigsListSlice: forRentWigsListSlice,
        forRentCostumesListSlice: forRentCostumesListSlice,
        forRentSetsListSlice: forRentSetsListSlice,
        forSaleWigsListSlice: forSaleWigsListSlice,
        forSaleEssentialsListSlice: forSaleEssentialsListSlice,
        forRentCostumesDetailsSlice: forRentCostumesDetailsSlice,
        forRentSetsDetailsSlice: forRentSetsDetailsSlice,
        forRentWigsDetailsSlice: forRentWigsDetailsSlice,
        forSaleWigsDetailsSlice: forSaleWigsDetailsSlice,
        forSaleEssentialsDetailsSlice: forSaleEssentialsDetailsSlice,
        itemTabsSlice: itemTabsSlice,
        itemInformationListSlice: itemInformationListSlice,
        itemPhotosAddSlice: itemPhotosAddSlice,
        itemPhotosListSlice: itemPhotosListSlice,
        itemPhotosDeleteSlice: itemPhotosDeleteSlice,

        bidsListSlice: bidsListSlice,
        bidsAddSlice: bidsAddSlice,
        bidsHomeSlice: bidsHomeSlice,
        bidItemSlice: bidItemSlice,
        requestRentSlice: requestRentSlice,
    },
});

if (window.Cypress) {
    window.store = store;
}